import React, {Component, useState} from 'react';

import "react-datepicker/dist/react-datepicker.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import Input from "../../components/TextInput"

import {
    Button, DataTable,
    Modal,
    Table, TableBody, TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
    TableToolbar,
    TableToolbarContent,
    ModalWrapper
} from "carbon-components-react";
import {Csv16, Undo16} from "@carbon/icons-react";
import Layout from "../Layout";
import "./index.scss"

export default class extends Component {

    state = {
        isOpenModal: false,
        isOpenSave: false,
        isDisabledSave: false,
    };

    render() {
        let {rows, headers, isLoading, contadorTotal, descDate, report} = this.props;

        return (
            <>
                <div>
                    <Modal
                        modalHeading=""
                        open={this.state.isOpenSave}
                        onRequestClose={e => this.setState({isOpenSave: false})}
                        size='xs'
                        passiveModal
                    >
                        <span><h3
                            className="color-title-h2">Report in process. You will receive a confirmation email once it's finished.</h3></span>

                    </Modal>

                </div>
                <div>
                    <Modal
                        modalHeading=""
                        open={this.state.isOpenModal}
                        onRequestClose={e => this.setState({isOpenModal: false})}
                        onRequestSubmit={e => (
                            this.setState({isOpenModal: false, isOpenSave: true, isDisabledSave: true})
                        )}
                        primaryButtonText="Confirm"
                        secondaryButtonText="Cancel"
                        size='xs'
                    >
                        <span><h3
                            className="color-title-h2">This action will generate a report using 14% of the available dataset.</h3></span>

                    </Modal>
                </div>

                <DataTable rows={rows} headers={headers}>
                    {({rows, headers, getHeaderProps, getTableProps}) => (
                        <TableContainer title="Report Preview"
                                        description="100 from 14,113 itens.         12 feb 21 - 29 jun 21"
                        >
                            <TableToolbar>
                                <TableToolbarContent>
                                    <Button
                                        disabled
                                        hasIconOnly
                                        renderIcon={Undo16}
                                        tooltipAlignment="center"
                                        tooltipPosition="top"
                                        iconDescription="Button description here"
                                        kind='secondary'
                                    />

                                    <Button
                                        tabIndex={0}
                                        onClick={e => (
                                            this.setState({isOpenModal: true})
                                        )}
                                        disabled={this.state.isDisabledSave}
                                        size="default"
                                        kind="primary"
                                    >
                                        SAVE
                                    </Button>
                                </TableToolbarContent>
                            </TableToolbar>
                            <Table {...getTableProps()} useZebraStyles size='tall'>
                                <TableHead>
                                    <TableRow>
                                        {headers.map((header) => (
                                            <TableHeader {...getHeaderProps({header})}>
                                                {header.header}
                                            </TableHeader>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row) => (
                                        <TableRow key={row.id}>
                                            {row.cells.map((cell) => (
                                                <TableCell key={cell.id}>{cell.value}</TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </DataTable>
            </>
        )
            ;
    }
}
